module.exports = __webpack_public_path__ + "static/img/printer.38b85b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/printer.png
// module id = YsR0
// module chunks = 1